import { isNil } from 'lodash';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getThirdPartyById } from '../../../services/thirdParty';

export function useGetThirdPartyDetail(
  tpId?: number,
  phase?: 'LEAD' | 'TP',
  enabled: boolean = true
) {

  const navigate = useNavigate();

  const thirdPartyQueryResult = useQuery(
    ['getThirdPartyById', tpId],
    () =>
      getThirdPartyById({ tpid: tpId! }).then((res) => {
        if (res.code === '401') {
          navigate('/third-party');
        }

        if (res.code === '403') {
          window.history.replaceState(null, '', '/403');
          window.location.reload();
        }
        return res.data;
      }),
    {
      enabled: !isNil(tpId) && phase === 'TP',
      refetchOnWindowFocus: false,
    }
  );

  const leadQueryResult = useQuery(
    ['getThirdPartyById', tpId],
    () => getThirdPartyById({ tpid: tpId! }).then((res) => res.data),
    {
      enabled: !isNil(tpId) && phase === 'LEAD',
    }
  );

  return phase === 'LEAD' ? leadQueryResult : thirdPartyQueryResult;
}
